<script>
import IconChevronDown from "@js/components/Icons/IconChevronDown.vue";
import {Link} from "@inertiajs/vue3";

export default {
    name: "MobileMenuDropdownBlock",
    components: {Link, IconChevronDown},
    props: {
        btnText: {
            required: true,
        },
        items: {},
    },
    data() {
        return {
            isOpen: this.forceOpen,
        }
    },
    methods: {
        toggleOpen() {
            this.isOpen = !this.isOpen;
        }
    }
}
</script>

<template>
    <div>
        <button type="button"
                class="flex items-center p-2 w-full text-base text-gray-900 rounded-lg transition duration-75 group hover:bg-gray-100"
                @click.prevent="toggleOpen">
            <span class="flex-1 ml-3 text-left font-medium">
                {{ btnText }}
            </span>
            <IconChevronDown :rotate="isOpen" class="w-5 h-5 transition-transform menu-chevron"/>
        </button>
        <ul v-if="isOpen" class="py-2 space-y-2">
            <li v-for="(item, index) in items" class="ms-5">
                <div v-if="item.submenu">
                    <MobileMenuDropdownBlock :btnText="item.title" :items="item.submenu"/>
                </div>
                <div v-else>
                    <Link :href="route(item.route_name, item.route_params ?? {})"
                          class="flex items-center p-2 pl-4 w-full text-base font-medium text-gray-900 rounded-lg transition duration-75 group hover:bg-gray-100">
                        {{ item.title }}
                    </Link>
                </div>
            </li>
        </ul>
    </div>
</template>

<style scoped lang="scss">

</style>
